<template>
    <div class="input-group input-large date-picker input-daterange close-button">
        <input type="text" ref="startInput" class="form-control" name="start"
               :class="{ 'input-error-date': erroFormato.start }"
               @focus="ocultarDatepicker" @input="processarValorInserido" @blur="emitChange">
        <span v-show="!onlyStart" ref="between" class="input-group-addon"> até </span>
        <input v-show="!onlyStart" type="text" ref="endInput" class="form-control" name="end"
               :class="{ 'input-error-date': erroFormato.end }"
               @focus="ocultarDatepicker" @input="processarValorInserido" @blur="emitChange">
        <span class="input-group-btn">
            <transition-group name="slide">
                <button v-if="gerarEnabled" class="btn blue" type="button" @click="apply" key="enabledbuttondate">                
                    {{buttonDescription}}
                </button>
                <button v-if="!gerarEnabled" class="btn blue disabled" type="button" key="disabledbuttondate">                
                    Carregando
                </button>
            </transition-group>
            
        </span>
    </div>
</template>
<script>
    export default {        
        props: {
            startDate : {
                default: ""
            },
            endDate: {
                default: ""
            },
            maxDate: {
                default: ""
            },
            minDate: {
                default: ""
            },
            buttonDescription: {
                default: "Aplicar"
            },
            gerarEnabled : {
                default: false
            },
            startView : {
                default: -1 // 0 - dia, 1 - mês, 2 - ano
            },
            onlyStart: {
                default: false
            },
            equalDates: {
                default: false
            }
        },
        data: function () {
            return {
                start: null,
                end: null,
                startText: "",
                endText: "",
                erroFormato: { start: false, end: false },
                dayOptions : {
                    format: "dd/MM/yyyy",
                    datepickerFormat: "dd/mm/yyyy",
                    startView: "days",
                    startViewIndex: 0
                },
                monthOptions : {
                    format: "MM/yyyy",
                    datepickerFormat: "mm/yyyy",
                    startView: "months",
                    startViewIndex: 1
                },
                yearOptions : {
                    format: "yyyy",
                    datepickerFormat: "yyyy",
                    startView: "years",
                    startViewIndex: 2
                },
                defaultOptions: {
                    format: "dd/MM/yyyy",
                    datepickerFormat: "dd/mm/yyyy",
                    startView: "months",
                    startViewIndex: 1
                }
            }
        },
        computed: {
            dateOptions() {
                if (this.startView == 0) return this.dayOptions;
                else if (this.startView == 1) return this.monthOptions;
                else if (this.startView == 2) return this.yearOptions;
                else return this.defaultOptions;
            }
        },
        methods: {  
            emitChange(e) {
                if (!e.originalEvent) return;
                var valorInserido = e.target.value;
                var nome = e.target.name;
                var formato = this.dateOptions.format.toUpperCase();

                // Campo vazio ou apagado: restaura o último valor válido
                if (!valorInserido.trim()) {
                    this._restaurarCampo(e.target, nome);
                    return;
                }

                var data = moment(valorInserido, formato, true);

                if (!data.isValid()) {
                    toastr.error('Data inválida. O formato esperado é ' + this.dateOptions.format + '.');
                    this._restaurarCampo(e.target, nome);
                    return;
                }

                this._aplicarData(e.target, nome, data.toDate());
            },
            // Ajusta a data ao início/fim do mês quando a periodicidade não é diária.
            _ajustarPeriodo(nome, data) {
                if (this.dateOptions.startViewIndex <= 0)
                    return data;

                // startOf('day') no fim do mes: sem isso a data sai 23:59:59.999 e o
                // toISOString() do filtro (UTC) joga o periodo para o mes seguinte.
                return nome === 'start'
                    ? moment(data).startOf('month').toDate()
                    : moment(data).endOf('month').startOf('day').toDate();
            },
            // Passa para o componente a data que veio do campo de texto. O datepicker do
            // bootstrap só dispara 'changeDate' quando a data é escolhida no calendário:
            // atualizado por código ele não avisa ninguém, e sem isto o valor digitado
            // ficaria apenas no <input>.
            _aplicarData(input, nome, dataInformada) {
                var finalDate = this._ajustarPeriodo(nome, dataInformada);

                window.$(input).datepicker('update', finalDate);
                if (nome === 'start') this.start = finalDate;
                else this.end = finalDate;

                this.erroFormato[nome] = false;
                this.$emit(nome + '-date-changed', finalDate);
            },
            // Lê e valida o texto do campo. Aceita com e sem barras, igual à digitação.
            _lerCampoData(input, nome) {
                var formato = this.dateOptions.format.toUpperCase();
                var valorInserido = (input.value || '').trim();
                var data = moment(valorInserido, formato, true);

                if (!data.isValid())
                    data = moment(valorInserido, formato.replace(/\//g, ""), true);

                if (!data.isValid()) {
                    this.erroFormato[nome] = true;
                    toastr.error('Data inválida. O formato esperado é ' + this.dateOptions.format + '.');
                    return null;
                }

                return this._ajustarPeriodo(nome, data.toDate());
            },
            processarValorInserido(e) {
                var valorInserido = e.target.value;
                var nome = e.target.name;
                var formato = this.dateOptions.format.toUpperCase();
                var formatoSemBarras = formato.replace(/\//g, "");

                // Ainda digitando: sem comprimento completo, sem erro
                if (valorInserido.length < Math.min(formato.length, formatoSemBarras.length)) {
                    this.erroFormato[nome] = false;
                    return;
                }

                var data = null;
                if (valorInserido.length === formato.length)
                    data = moment(valorInserido, formato, true);
                else if (valorInserido.length === formatoSemBarras.length)
                    data = moment(valorInserido, formatoSemBarras, true);

                if (data && data.isValid()) {
                    this.erroFormato[nome] = false;
                    window.$(e.target).datepicker('update', data.toDate());
                } else if (valorInserido.length >= formato.length) {
                    // Comprimento atingido mas data inválida: feedback visual imediato
                    this.erroFormato[nome] = true;
                }
            },
            ocultarDatepicker(e) {
                window.$(e.target).datepicker('hide');
            },
            _restaurarCampo(input, nome) {
                var valorAnterior = nome === 'start' ? this.start : this.end;
                if (valorAnterior) {
                    input.value = moment(valorAnterior).format(this.dateOptions.format);
                    window.$(input).datepicker('update', valorAnterior);
                } else {
                    input.value = '';
                }
                this.erroFormato[nome] = false;
            },                   
            // Gera com o que está escrito nos campos: digitar o período e clicar precisa valer
            // tanto quanto escolhê-lo no calendário.
            apply: function () {
                var inicio = this._lerCampoData(this.$refs.startInput, 'start');
                if (!inicio)
                    return;

                var fim = this.onlyStart ? inicio : this._lerCampoData(this.$refs.endInput, 'end');
                if (!fim)
                    return;

                if (!this.equalDates && inicio.toString() === fim.toString()) {
                    this.$emit('error-input', 1);
                    return;
                }

                if (inicio > fim) {
                    this.$emit('error-input', 2);
                    return;
                }

                this._aplicarData(this.$refs.startInput, 'start', inicio);
                if (!this.onlyStart)
                    this._aplicarData(this.$refs.endInput, 'end', fim);

                this.$emit("apply", { start: inicio, end: fim });
            },
            init: function() {
                this.startText = this.start.format(this.dateOptions.format);
                this.$refs.startInput.value = this.startText;
                this.endText = this.end.format(this.dateOptions.format);
                this.$refs.endInput.value = this.endText;

                let vm = this;

                let datepicker = window.$(this.$el).datepicker({
                    language: 'pt-BR',
                    orientation: "left",
                    format: vm.dateOptions.datepickerFormat,
                    startView: vm.dateOptions.startView,
                    minViewMode: vm.dateOptions.startView,
                    autoClose: true,
                    startDate: this.minDate,
                    endDate: this.maxDate
                }).on('changeDate', function (arg) {   
                    if (arg.target.name === "start"){
                        vm.start = arg.date;                                                     
                        window.$(vm.$refs.startInput).datepicker('hide');                                      
                        if (!vm.onlyStart)
                            window.$(vm.$refs.endInput).datepicker("show");
                    }                                                        
                        
                    if (arg.target.name === "end"){
                        var currentDate = arg.date;
                        if (vm.dateOptions.startViewIndex > 0)
                            currentDate = new Date(arg.date.getFullYear(), arg.date.getMonth() + 1, 0);
                        window.$(vm.$refs.endInput).datepicker('update', currentDate);
                        vm.end = currentDate;                                                                
                        window.$(vm.$refs.endInput).datepicker('hide');                             
                    }   
                    
                    if (vm.start && vm.end) {
                        vm.$emit("change", { event: arg, start: vm.start, end: vm.end });
                    }                
                });
            }
        },
        watch: {
            start(val) {
                this.$emit("start-date-changed", val);
            },
            end: function(val){
                this.endText = val.format(this.dateOptions.format);
                this.$emit("end-date-changed", val);             
            },
            startView: function(val){
                console.log("watch: ",val);
                this.start = new Date(this.start.getFullYear(), this.start.getMonth(), 1);;
                this.end = new Date(this.end.getFullYear(), this.end.getMonth() + 1, 0);
                    console.log("watch2: ", this.start, this.end);

                this.init();
            },
            startDate(val) {
                this.start = val;
                window.$(this.$refs.startInput).datepicker('update', val);
            },
            endDate(val) {
                this.end = val;
                window.$(this.$refs.endInput).datepicker('update', val);
            }
        },
        mounted: function () {
            if (!this.start && this.startDate) {
                this.start = this.startDate;                                
            } else {
                this.start = moment(new Date()).toDate().addDays(-1);
            }
            
            if (!this.end && this.endDate) {
                this.end = this.endDate;                
            } else {
                this.end = moment(new Date()).toDate();
            }
            
            this.init();
        }
    }
</script>
<style scoped>
.input-error-date {
    border-color: #e73d4a !important;
    background-color: #fff0f1;
}
</style>